var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFullScreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Full screen",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0.818182C0 0.366316 0.366316 0 0.818182 0H5.72727C6.17914 0 6.54545 0.366316 6.54545 0.818182C6.54545 1.27005 6.17914 1.63636 5.72727 1.63636H1.63636V5.72727C1.63636 6.17914 1.27005 6.54545 0.818182 6.54545C0.366316 6.54545 0 6.17914 0 5.72727V0.818182ZM11.4545 0.818182C11.4545 0.366316 11.8209 0 12.2727 0H17.1818C17.6336 0 18 0.366316 18 0.818182V5.72727C18 6.17914 17.6336 6.54545 17.1818 6.54545C16.73 6.54545 16.3636 6.17914 16.3636 5.72727V1.63636H12.2727C11.8209 1.63636 11.4545 1.27005 11.4545 0.818182ZM0.818182 11.4545C1.27005 11.4545 1.63636 11.8209 1.63636 12.2727V16.3636H5.72727C6.17914 16.3636 6.54545 16.73 6.54545 17.1818C6.54545 17.6336 6.17914 18 5.72727 18H0.818182C0.366316 18 0 17.6336 0 17.1818V12.2727C0 11.8209 0.366316 11.4545 0.818182 11.4545ZM17.1818 11.4545C17.6336 11.4545 18 11.8209 18 12.2727V17.1818C18 17.6336 17.6336 18 17.1818 18H12.2727C11.8209 18 11.4545 17.6336 11.4545 17.1818C11.4545 16.73 11.8209 16.3636 12.2727 16.3636H16.3636V12.2727C16.3636 11.8209 16.73 11.4545 17.1818 11.4545Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullScreen);
export default __webpack_public_path__ + "static/media/full-screen.ac4882154edb0175cc76c0e7a515decd.svg";
export { ForwardRef as ReactComponent };